import axios from "axios";

// 创建 axios 实例
const service = axios.create({
  baseURL: "https://admin.xingxingaixiezuo.com/api",
  // baseURL: "http://manuscript.zslyoo.top/api",
  timeout: 10000,
});

// 用于防止重复跳转到登录页
let isRedirecting = false;

// 清除登录信息并跳转的函数
function clearAuthAndRedirect() {
  if (isRedirecting) {
    return; // 如果正在跳转，直接返回
  }
  
  // 清除登录信息
  localStorage.removeItem("token");
  localStorage.removeItem("isLoggedIn");
  localStorage.removeItem("userName");
  localStorage.removeItem("userAvatar");
  localStorage.removeItem("userId");
  localStorage.removeItem("userInfo");
  
  // 检查当前路径，避免重复跳转
  const currentHash = window.location.hash || '';
  const currentPath = currentHash.replace('#', '');
  if (currentPath !== "/login" && currentPath !== "/#/login" && currentPath !== "#/login") {
    isRedirecting = true;
    // 延迟跳转，避免多个请求同时触发
    setTimeout(() => {
      // 使用 hash 方式跳转，不受 base URL 影响
      window.location.hash = '#/login';
      isRedirecting = false;
    }, 100);
  }
}

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 从 localStorage 获取 token
    let token = localStorage.getItem("token");
    
    // 如果直接没有token，尝试从userInfo中获取
    if (!token) {
      const userInfo = localStorage.getItem("userInfo");
      if (userInfo) {
        try {
          const userInfoObj = JSON.parse(userInfo);
          token = userInfoObj.token || (userInfoObj.userinfo && userInfoObj.userinfo.token);
          // 如果从userInfo中找到了token，保存到单独的token键中
          if (token) {
            localStorage.setItem("token", token);
          }
        } catch (e) {
          console.error('解析userInfo失败:', e);
        }
      }
    }
    
    if (token) {
      // 确保token被添加到请求头
      config.headers['token'] = token;
    } else {
      console.warn('未找到token，请先登录');
    }
    return config;
  },
  (error) => {
    console.error("请求错误:", error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    // code: 1 表示成功，0 表示失败，401 表示未授权
    if (res.code === 0) {
      return Promise.reject(new Error(res.msg || "请求失败"));
    }
    // 处理 code === 401 的情况（业务层面的未授权）
    if (res.code === 401) {
      clearAuthAndRedirect();
      return Promise.reject(new Error(res.msg || "请登录后操作"));
    }
    // code === 1 或其他成功情况，返回数据
    return res;
  },
  (error) => {
    // 处理 HTTP 401 未授权错误
    if (error.response && error.response.status === 401) {
      clearAuthAndRedirect();
      // 从响应数据中获取错误消息
      const errorMsg = error.response.data && error.response.data.msg 
        ? error.response.data.msg 
        : "请登录后操作";
      return Promise.reject(new Error(errorMsg));
    }
    // 如果是网络错误或其他错误，尝试获取错误信息
    if (error.response && error.response.data) {
      const res = error.response.data;
      if (res.code === 0) {
        return Promise.reject(new Error(res.msg || "请求失败"));
      }
      if (res.code === 401) {
        clearAuthAndRedirect();
        return Promise.reject(new Error(res.msg || "请登录后操作"));
      }
    }
    // 处理网络错误
    if (!error.response) {
      return Promise.reject(new Error("网络错误，请检查网络连接"));
    }
    // 其他错误，返回原始错误信息
    const errorMsg = error.response.data && error.response.data.msg 
      ? error.response.data.msg 
      : (error.message || "请求失败");
    return Promise.reject(new Error(errorMsg));
  }
);

export default service;
